// extracted by mini-css-extract-plugin
export default {"CandidateResumePage__blur":"qRVV0"};